import { WebShopIcon } from "@/src/components/WebShopIcon";

export function Icons(props: any) {
  return (
    <WebShopIcon
      name={props.icon}
      height={props.size}
      width={props.size}
      fill={props.color}
      className={props.className}
    />
  );
}
